const HidePasswordIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.015 2.45474C21.3161 2.73915 21.3297 3.21383 21.0453 3.51497L4.04526 21.515C3.76085 21.8161 3.28617 21.8297 2.98503 21.5453C2.68389 21.2609 2.67033 20.7862 2.95474 20.485L6.04677 17.2111C4.77761 16.3481 3.64619 15.1853 2.74238 13.7291C2.08587 12.6713 2.08587 11.3287 2.74238 10.2709C5.92231 5.14757 11.8829 3.7055 16.6203 6.01564L19.9547 2.48503C20.2391 2.1839 20.7138 2.17033 21.015 2.45474ZM15.5323 7.16764C11.554 5.4774 6.69051 6.75428 4.01685 11.062C3.66105 11.6352 3.66105 12.3648 4.01685 12.938C4.86031 14.297 5.91843 15.3498 7.09216 16.1042L9.07091 14.0091C8.67848 13.4379 8.44824 12.7455 8.44824 12C8.44824 10.0386 10.0382 8.44861 11.9996 8.44861C12.6722 8.44861 13.302 8.63611 13.8383 8.96122L15.5323 7.16764ZM12.7662 10.0964L10.143 12.874C10.0179 12.6088 9.94824 12.3127 9.94824 12C9.94824 10.867 10.8667 9.94861 11.9996 9.94861C12.2709 9.94861 12.5295 10.001 12.7662 10.0964Z"
        fill="#2F2E2C"
      />
      <path
        d="M19.6331 8.19454C19.3429 7.89894 18.8681 7.89453 18.5725 8.18469C18.2769 8.47485 18.2725 8.9497 18.5626 9.2453C19.0814 9.77382 19.5592 10.379 19.9832 11.062C20.3389 11.6352 20.3389 12.3648 19.9832 12.938C17.714 16.5939 13.8738 18.0603 10.3425 17.3993C9.93533 17.323 9.54349 17.5913 9.46727 17.9984C9.39106 18.4056 9.65932 18.7974 10.0665 18.8736C14.204 19.6482 18.661 17.9126 21.2576 13.7291C21.9141 12.6713 21.9141 11.3287 21.2576 10.2709C20.7765 9.49579 20.2306 8.80326 19.6331 8.19454Z"
        fill="#2F2E2C"
      />
    </svg>
  );
};

export default HidePasswordIcon;
